// extracted by mini-css-extract-plugin
module.exports = {"allLinks":"links_allLinks__W66fB","link":"links_link__2w_rM","linkActive":"links_linkActive__2pjjB"};